import { render, staticRenderFns } from "./LicenseTerms.vue?vue&type=template&id=666f9734&"
import script from "./LicenseTerms.vue?vue&type=script&lang=js&"
export * from "./LicenseTerms.vue?vue&type=script&lang=js&"
import style0 from "./LicenseTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports